<template>
    <v-dialog v-model="singleViewDialog">
        <div v-if="isLoadingSingleView && attentionsTableItemCount == 0">
            <LoadingSkeleton />
        </div>
        <v-card v-else>
            <v-card-title primary-title class="d-block">
                <v-row dense justify="space-between">
                    <v-col cols="10">
                        <div
                            v-if="$vuetify.breakpoint.smAndDown"
                            class="primary--text text-overline ml-2"
                        >
                            {{
                                currentComercial ? currentComercial.nombre : ''
                            }}
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            <div class="d-flex align-center">
                                <v-icon color="primary" left x-large>
                                    mdi-text-account
                                </v-icon>
                                {{
                                    currentComercial
                                        ? currentComercial.nombre
                                        : ''
                                }}
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end align-center">
                        <div v-if="!$vuetify.breakpoint.smAndDown">
                            <v-btn
                                color="success"
                                outlined
                                @click="downloadAttentionReport"
                            >
                                {{
                                    exportingProgress != 0
                                        ? `${exportingProgress.toFixed(0)} %`
                                        : 'Descargar Reporte'
                                }}
                                <v-icon right large>
                                    mdi-microsoft-excel
                                </v-icon>
                            </v-btn>
                        </div>
                        <div v-else>
                            <v-btn
                                color="success"
                                small
                                outlined
                                @click="downloadAttentionReport"
                            >
                                {{
                                    exportingProgress != 0
                                        ? `${exportingProgress.toFixed(0)} %`
                                        : ''
                                }}
                                <v-icon> mdi-microsoft-excel </v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="isExporting">
                    <v-col cols="12">
                        <v-progress-linear
                            :value="exportingProgress"
                            :indeterminate="exportingProgress == 0"
                            height="4"
                            color="#4CAF50"
                            background-color="grey lighten-2"
                        >
                        </v-progress-linear>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-divider class="test" />
            <v-card-text class="pa-0">
                <v-row no-gutters>
                    <v-col cols="12" :md="!checkEmptyDict ? 9 : 12">
                        <ComercialesTableAttentionsTable />
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                        v-if="!checkEmptyDict"
                        class="d-flex justify-center align-center"
                    >
                        <ComercialesTableSingleStats />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn text color="red" @click="close()"> Cerrar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import PieChart from './PieChart.js';
import { mapState } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import ComercialesTableAttentionsTable from '@/components/GerenciaTeletrabajo/ComercialesTable/SingleView/ComercialesTableAttentionsTable.vue';
import ComercialesTableSingleStats from '@/components/GerenciaTeletrabajo/ComercialesTable/SingleView/ComercialesTableSingleStats.vue';

export default {
    name: 'ComercialesTableSingleViewDialog',
    components: {
        PieChart,
        LoadingSkeleton,
        ComercialesTableAttentionsTable,
        ComercialesTableSingleStats,
    },
    data: () => ({
        message: '',
        OfertasTipoOptions: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                display: true,
                position: 'right',
                align: 'start',
            },
            legendCallback: function (chart) {
                var arr = [];
                for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
                    if (chart.data.labels[i]) {
                        arr.push({
                            label: chart.data.labels[i],
                            color: chart.data.datasets[0].backgroundColor[i],
                        });
                    }
                }
                return arr;
            },
        },
    }),
    computed: {
        singleViewDialog: {
            get() {
                return this.$store.state.gerencia.singleViewDialog;
            },
            set(val) {
                if (!val)
                    this.$store.commit('gerencia/attentionsTableItemCount', 0);

                this.$store.commit('gerencia/singleViewDialog', val);
            },
        },
        checkEmptyDict() {
            let value = true;

            if (this.currentComercial)
                Object.keys(this.currentComercial).forEach((field) => {
                    if (
                        !isNaN(this.currentComercial[field]) &&
                        this.currentComercial[field] != 0
                    )
                        value = false;
                });

            return value;
        },
        ...mapState('gerencia', {
            attentionsTableItemCount: (state) => state.attentionsTableItemCount,
            comercialesInfo: (state) => state.comercialesInfo,
            currentComercial: (state) => state.currentComercial,
            isLoadingSingleView: (state) => state.isLoadingSingleView,
        }),
        ...mapState('util', {
            isExporting: (state) => state.isExporting,
            exportingProgress: (state) => state.exportingProgress,
        }),
    },
    methods: {
        close() {
            console.log(this.checkEmptyDict);
            this.$store.commit('gerencia/singleViewDialog', false);
        },
        setLegend(html) {
            this.message = html;
        },
        downloadAttentionReport() {
            this.$store.dispatch('gerencia/exportAttentions');
        },
    },
};
</script>
